import React, {useCallback, useState} from 'react';
import {Button, Flex, HTMLDialog, Text} from '@priority-software/priority-style-react';
import {DialogToolbarContent} from '../../../../../../components/Dialog/DialogToolbar/DialogToolbar';
import {ScrollableList} from '../AddPortletDialog/parts/ScrollableList/ScrollableList';
import texts from '../../../../texts';
import {homepageStore} from '../../../../store/HomepageStore';
import {getGroupTitle} from '../../../../utils';
import {DefaultGroupsIDs} from '../../../../enums';
import styles from './styles.module.scss';
import {addTile} from '../../../../actions/dialogs';

export const AddToHomepageDialog = (props: {
    onClose: () => void;
    itemToAdd?: {exec: string; title: string};
}) => {
    const {onClose: closeDialog, itemToAdd} = props;
    const {groups} = homepageStore;
    const [isPending, setPending] = useState(false);

    const [options] = useState(
        Array.from(groups.keys())
            .filter(groupName => groupName !== DefaultGroupsIDs.insights)
            .map(groupName => ({label: getGroupTitle(groupName), value: groupName})) || []
    );
    const [selectedItem, setSelectedItem] = useState(options[0] || null);

    const onItemClick = useCallback(item => {
        setSelectedItem(item);
    }, []);

    const onSave = async (groupTitle?: string) => {
        if (itemToAdd && groupTitle) {
            setPending(true);
            await addTile(itemToAdd.exec, itemToAdd.title, groupTitle);
            setPending(false);
            closeDialog();
        }
    };

    return (
        <HTMLDialog
            isOpen
            onClose={closeDialog}
            width={720}
            componentClasses={styles.component}
            toolbarContent={<DialogToolbarContent mainTitle={texts.add_to_homepage_dialog_title} />}
            title={
                <div style={{paddingBottom: 24}}>
                    <Text skin="paragraph-2" style={{padding: '0 8px 8px'}}>
                        {texts.add_to_homepage_dialog_content}
                    </Text>
                </div>
            }
            content={
                <div style={{height: '100%', display: 'flex', overflow: 'hidden'}}>
                    <ScrollableList
                        data={options}
                        onItemClick={onItemClick}
                        showSearch={false}
                        selectedValue={selectedItem?.value}
                        componentClasses={styles.scrollableList}
                    />
                </div>
            }
            footer={
                <Flex justifyContent="flex-end" style={{gap: 24}}>
                    <Button onClick={closeDialog} wideButton skin="secondary" size="medium">
                        {texts.btn_cancel}
                    </Button>
                    <Button
                        onClick={() => onSave(selectedItem?.value)}
                        disabled={isPending || Boolean(!selectedItem)}
                        wideButton
                        skin="primary"
                        size="medium"
                    >
                        {texts.btn_add}
                    </Button>
                </Flex>
            }
        />
    );
};
